module.exports = __webpack_public_path__ + "static/media/login-img.75f4e2ad.jpg";